module.exports = __webpack_public_path__ + "static/media/Jerry Voigt Headshot_1722559939757.3165059e.jpeg";